import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engineers',
  templateUrl: './engineers.component.html',
  styleUrls: ['./engineers.component.scss']
})
export class EngineersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
